import * as angular from 'angular';

import { ComponentDefinition, EmailEventDTO } from '../../../models';
import { IRecipientsHelper, IRecipientsComponentViewModel } from '../../../services';
import { IRootScope } from 'IRootScope';
import { toggleEditMode, guidEmpty } from '../../../common';
import { IEditSendMailActionService } from '../../services.index';

class EditEventEmailStateController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    htmlText: string;
    isEditMode: boolean;
    email: EmailEventDTO;
    recipients: IRecipientsComponentViewModel;

    static $inject = [
        '$rootScope',
        '$stateParams',
        'recipientsHelper',
        'editSendMailActionService',
    ];

    constructor(
        private $rootScope: IRootScope,
        private $stateParams: angular.ui.IStateParamsService,
        private _recipientsHelper: IRecipientsHelper,
        private _editSendMailActionService: IEditSendMailActionService,
     ) {
    }

    $onInit() {
        if (!this.$rootScope.isEditMode) {
            this.$rootScope.$broadcast(toggleEditMode, true);
        }
        this.isEditMode = true;
        this.email = this.$stateParams['item'];

        const strategy = this.email.approvalStrategyGuid && this.email.approvalStrategyGuid !== guidEmpty
            ? this.email.approvalStrategyGuid
            : undefined;

        this._recipientsHelper
            .loadRecipients(strategy, true)
            .then(r => this.recipients = r);
    }

    // send test email
    send() {
        this.isLoading = true;
        this._editSendMailActionService
            .send(this.email.eventEmailDefinition)
            .finally(() => this.isLoading = false);
    }
}

export const wtEditEventEmailState: ComponentDefinition = {
    componentId: 'wtEditEventEmailState',
    controller: EditEventEmailStateController,
    template: require('./editEventEmailState.component.html'),
    controllerAs: 'vm',
    bindings: {}
};